<template>
  <div class="ret-cards-wrapper">
    <v-card class="ret-card-new">
      <v-card-text v-if="csvImports.length > 0">
        <div v-for="(csvImportName, index) in csvImports" :key="index">
          <input :id="csvImportName" type="file" accept=".csv" style="display:none" @change="doneFileSelect"/>
          <v-btn @click="initFileSelect(csvImportName)">{{ csvImportName }}</v-btn>
        </div>

        <p v-if="result">{{ result }}</p>
        <p v-if="error" style="color: red">{{ error }}</p>
      </v-card-text>
      <v-card-text v-if="csvImports.length === 0">
        <div>
          {{ $t('no-data-available') }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [],
      items: [],
      result: undefined,
      error: undefined
    }
  },
  computed: {
    csvImports () {
      return this.$store.state.site.csvImports || []
    }
  },
  methods: {
    initFileSelect (csvImportName) {
      const fileInput = document.getElementById(csvImportName)
      if (fileInput) {
        fileInput.click()
      }
    },
    doneFileSelect (evt) {
      const csvImportName = evt.srcElement.id
      // Resetting any previous result/error
      this.result = undefined
      this.error = undefined

      // Getting the file
      const csvFile = evt && evt.path && evt.path[0] && evt.path[0].files && evt.path[0].files[0]
      let formData = new FormData()
      formData.append('file', csvFile)
      formData.append('csvImportName', csvImportName)

      // Calling the BE
      if (csvFile) {
        this.$store.dispatch('importCSV', { csvFile: formData })
          .then((response) => {
            if (response && response.status >= 200 && response.status <= 299) {
              this.result = 'Import has been completed successfully.'
            } else {
              console.log(response)
              this.error = response.data.message
            }
          })
      }
    }
  }
}
</script>
